import { render, staticRenderFns } from "./OutingDetailNeedsMealsTable.vue?vue&type=template&id=2d43512d&lang=pug"
import script from "./OutingDetailNeedsMealsTable.vue?vue&type=script&lang=ts"
export * from "./OutingDetailNeedsMealsTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports